<div class="row flex-shrink">
    <div class="col-md-7">
        <ol class="breadcrumb">
            <li>
                <a [routerLink]="['/admin/announcements']">Announcements</a>
            </li>
        </ol>
    </div>
    <div class="col-md-3">
    </div>
    <div class="col-md-2">
        <button class="btn btn-primary col-md-12" routerLink="/admin/announcements/create">Create Announcement</button>
    </div>
    <div style="padding: 0;">
        <table aria-describedby="Announcement Table" class="table announcement-table table-striped table-hover">
            <thead>
            <tr>
                <th scope="col" class="announcement-id-header">Id</th>
                <th scope="col" class="announcement-type-header">Type</th>
                <th scope="col" class="announcement-title-header">Title</th>
                <th scope="col" class="announcement-txt-header">Text</th>
                <th scope="col" class="status-header">Status</th>
                <th scope="col" class="effective-date-header">Effective Date (CST)</th>
                <th scope="col" class="end-date-header">End Date (CST)</th>
                <th scope="col" class="link-txt-header">Link Text</th>
                <th scope="col" class="link-url-header">Link Url</th>
                <th scope="col" class="release-number-header">Release</th>
            </tr>
            </thead>
            <tbody id="announcementScrollPane">
            <tr *ngFor="let announcement of activeRecordList">
                <td class="announcement-id-cell"><a [routerLink]="[announcement.announcementId]">{{announcement.announcementId}}</a></td>
                <td class="announcement-type-cell">{{announcement.announcementType.announcementTypeCde}}</td>
                <td class="announcement-title-cell">{{announcement.announcementTitle.length <= 40 ? announcement.announcementTitle :((announcement.announcementTitle | slice:0: 40) + '...')}}</td>
                <td class="announcement-txt-cell">{{announcement.announcementTxt.length <= 40 ? announcement.announcementTxt :((announcement.announcementTxt | slice:0: 40) + '...')}}</td>
                <td class="status-cell"><span [attr.class]="statusForDatesForView(announcement.effectiveDate, announcement.endDate)">{{statusForDates(announcement.effectiveDate, announcement.endDate)}}</span></td>
                <td class="effective-date-cell">{{announcement.effectiveDate | date:'yyyy-MM-dd HH:mm:ss'}}</td>
                <td class="end-date-cell">{{announcement.endDate | date:'yyyy-MM-dd HH:mm:ss'}}</td>
                <td class="link-txt-cell"><span *ngIf="announcement.linkTxt.length > 0">{{announcement.linkTxt.length <= 40 ? announcement.linkTxt :((announcement.linkTxt | slice:0: 40) + '...')}}</span></td>
                <td class="link-url-cell"><span *ngIf="announcement.linkTxt.length > 0">{{announcement.linkUrl.length <= 40 ? announcement.linkUrl :((announcement.linkUrl | slice:0: 40) + '...')}}</span></td>
                <td class="release-number-cell">{{announcement.releaseNumber}}</td>
            </tr>
            </tbody>
        </table>
        <div class="table-tools">
            <div class="pagination-button"><announcementpagination></announcementpagination></div>
        </div>
    </div>
</div>
